import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LoanFund = Loadable(lazy(() => import("./LoanFund")));

const loanfundRoute = [{ path: "/loan-fund", element: <LoanFund /> }];
export default loanfundRoute;
